import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
//eslint-disable-next-line
import { css } from "styled-components/macro";
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { ReactComponent as Oca } from "images/oca_marrone.svg";
import {useTranslation} from "react-i18next";

const Container = tw.div`relative`;

const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-lg mx-auto py-20 md:py-24`}
`;
const Subheading = tw(SubheadingBase)`mb-4`;
const Heading = tw(SectionHeading)`w-full`;
const Title = tw.span`w-full text-base`;

const VerticalSpacer = tw.div`mt-10 w-full`

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/2 max-w-sm`}
`;

const Card = styled.div`
  ${tw`flex flex-col sm:flex-row items-center sm:items-start text-center sm:text-left h-full mx-1 px-2 py-2`}

  .title {
    ${tw`mt-4 tracking-wide font-bold text-2xl leading-none`}
  }


`;

const DecoratorBlob = styled(Oca)`
  ${tw`pointer-events-none absolute right-0 bottom-0 w-[92rem] translate-x-[48rem] translate-y-32`}
`;

export default ({ cards = null, subheading = "", description = "" }) => {
  /*
   * This componets has an array of object denoting the cards defined below. Each object in the cards array can have the key (Change it according to your need, you can also add more objects to have more cards in this feature component) or you can directly pass this using the cards prop:
   *  1) imageSrc - the image shown at the top of the card
   *  2) title - the title of the card
   *  3) description - the description of the card
   *  If a key for a particular card is not provided, a default value is used
   */

  const { t } = useTranslation();

  const defaultCards = [
    { imageSrc: "", title: t("services.1") },
    { imageSrc: "", title: t("services.2") },
    { imageSrc: "", title: t("services.3") },
    { imageSrc: "", title: t("services.4") },
    { imageSrc: "", title: t("services.5") },
    { imageSrc: "", title: t("services.6") },
    { imageSrc: "", title: t("services.7") },
    { imageSrc: "", title: t("services.8") },

  ];


  if (!cards) cards = defaultCards;

  return (
    <Container id="contatti">
      <ThreeColumnContainer>
        {subheading && <Subheading>{subheading}</Subheading>}
        <Heading>{t('menu.contacts')}</Heading>
        <VerticalSpacer />
        {cards.map((card, i) => (
          <Column key={i}>
            <Card>
              <Title>{card.title}</Title>
            </Card>
          </Column>
        ))}
      </ThreeColumnContainer>
      <DecoratorBlob />
    </Container>
  );
};
